import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Route-level Studio Team guard, the permission twin of FeatureRoute. Hiding a nav item
// only removes the link; a typed URL still renders the page, so each gated route is
// wrapped here. Sends a member to the first page their role CAN open (a bookkeeper to
// Payments) instead of Overview, which they may not have either.
//
// `membership` is null while /auth/me is in flight AND for students — don't redirect then;
// the dashboard guard already handles students.
export const homeFor = (can) => (can('dashboard.overview') ? '/dashboard'
  : can('payments.read') ? '/dashboard/payments'
    : can('invoicing.read') ? '/dashboard/invoices'
      : '/dashboard/settings');

export default function PermissionRoute({ permission, children }) {
  const { membership, can } = useAuth();
  if (membership && !can(permission)) {
    return <Navigate to={homeFor(can)} replace />;
  }
  return children;
}
